import { NextSeo } from 'next-seo';

export function NextJSSEOWrapper({
  title,
  description,
  keywords,
  noindex,
  nofollow,
}: {
  title?: string;
  description?: string;
  keywords?: string[];
  noindex?: boolean;
  nofollow?: boolean;
}) {
  return (
    <NextSeo
      title={title}
      description={description}
      additionalMetaTags={
        keywords && [
          {
            name: 'keywords',
            content: keywords.join(', '),
          },
        ]
      }
      noindex={noindex}
      nofollow={nofollow}
    />
  );
}

